import { Box } from "@mui/material";

export default function Logo({ size = 40 }) {
    return (
        <Box
            component="img"
            src="/assets/logo/appLogo.png"
            alt="BusGo"
            sx={{
                width: size,
                height: size,
                objectFit: "contain",
                flexShrink: 0,
            }}
        />
    );
}
